var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenbadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421",
    transform: "translate(-335 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(335 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433",
    transform: "translate(273.329 328.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(66.171 151.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8186",
    "data-name": "Path 8186",
    d: "M74.171,151.085l-8,4.619v9.238l8,4.619,8-4.619V155.7Z",
    transform: "translate(-66.171 -151.085)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(66.702 151.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8190",
    "data-name": "Path 8190",
    className: "openbadge",
    d: "M89.1,168.867l-7.469,4.313V181.8l7.469,4.313,7.47-4.313V173.18Zm2.76,2.7,1.388.8v6.965l-1.388-.8Zm-2.281-1.316,1.322.762v6.965l-1.322-.763Zm-6.989,3.481,6.03-3.481v1.581l-6.03,3.482Zm0,2.69,6.03-3.482v1.572L82.591,178Zm0,2.68,6.03-3.482v1.595l-6.03,3.482Zm6.51,5.908-6.03-3.482,1.417-.818,6.03,3.482Zm2.376-1.371-6.03-3.482,1.372-.792,6.031,3.481Zm2.332-1.347-6.031-3.482,1.323-.764,6.031,3.482Zm1.8-1.595-1.4-.81v-6.965l1.4.81Z",
    transform: "translate(-81.632 -168.867)",
    fill: "#083f85"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenbadge);
export default __webpack_public_path__ + "static/media/openbadge.92c48365.svg";
export { ForwardRef as ReactComponent };